import AbstractColumn from './AbstractColumn'

export default class DateColumn extends AbstractColumn {
  constructor (field) {
    super()
    this.init(field)
    this.type = 'date'
    this.htmlType = 'date'
    this.dateInputFormat = 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\''
    this.dateOutputFormat = 'dd/MM/yyyy'
    this.dateFormatToSave = 'yyyy-MM-dd'
  }

  withDateInputFormat (dateInputFormat) {
    this.dateInputFormat = dateInputFormat
    return this
  }

  withDateOutputFormat (dateOutputFormat) {
    this.dateOutputFormat = dateOutputFormat
    return this
  }

  withDateFormatToSave (dateFormatToSave) {
    this.dateFormatToSave = dateFormatToSave
    return this
  }
}
